import { render, staticRenderFns } from "./LaborRegistDaily.vue?vue&type=template&id=45a296f0&scoped=true&"
import script from "./LaborRegistDaily.vue?vue&type=script&lang=ts&"
export * from "./LaborRegistDaily.vue?vue&type=script&lang=ts&"
import style0 from "./LaborRegistDaily.vue?vue&type=style&index=0&id=45a296f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a296f0",
  null
  
)

export default component.exports